import styled from "styled-components";

export const PageDescription = styled.div`
  margin-bottom: 1rem;
`;
